module.exports = {
  locales: ['default', 'de', 'en', 'fr', 'it'],
  defaultLocale: 'default',
  pages: {
    '*': ['common'],
  },
};
